"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonInner = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* ButtonInner contains styles that make the button look like a button,
 * and is the Button subcomponent that is themable using ButtonPrimary's colorSet prop
 */
var ButtonInner = exports.ButtonInner = _styledComponents["default"].span.withConfig({
  displayName: "ButtonInner",
  componentId: "sc-14ud5tc-0"
})(["", ";", ""], function (_ref) {
  var $UNSAFE_colorSet = _ref.$UNSAFE_colorSet;
  return $UNSAFE_colorSet ? (0, _index.cssColorSet)($UNSAFE_colorSet) : '';
}, function (_ref2) {
  var $fallbackSet = _ref2.$fallbackSet,
    $buttonSize = _ref2.$buttonSize,
    $iconLeading = _ref2.$iconLeading,
    $iconTrailing = _ref2.$iconTrailing,
    $iconOnly = _ref2.$iconOnly,
    $status = _ref2.$status;
  var padding = (0, _index.getButtonPadding)({
    buttonSize: $buttonSize,
    iconPlacement: (0, _index.getIconPlacement)({
      iconOnly: $iconOnly,
      iconLeading: $iconLeading,
      iconTrailing: $iconTrailing
    }),
    status: $status
  });
  return (0, _styledComponents.css)(["", ";position:relative;background-color:var(--background-base,", ");color:var(--text-base,", ");display:flex;border-radius:", ";font-size:inherit;min-block-size:", ";align-items:center;justify-content:center;", ";", ";transition-property:background-color,transform;transition-duration:", ";"], (0, _index.rootStyle)(), $fallbackSet.background.base, $fallbackSet.text.base, _index.buttonBorderRadius, (0, _index.cssControlSize)((0, _index.slControlSize)($buttonSize), _index.controlSizeFallback[$buttonSize]), padding, (0, _index.overflowWrapFlexText)(), _index.buttonTransitionFade);
});